import { Injectable, Renderer2 } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Injectable()
export class Tipp3ScriptsService {

  constructor() { }

  inject(renderer: Renderer2, newsTextContainer: HTMLElement) {
    if (!newsTextContainer) {
      return;
    }
    const targetElem = this.getTipp3WidgetTargetElement(newsTextContainer);
    if (!targetElem) {
      return;
    }
    const tipp3Container: HTMLDivElement = renderer.createElement('div');
    const widgetContainer: HTMLDivElement = renderer.createElement('div');
    const setupScript: HTMLScriptElement = renderer.createElement('script');
    const pushScript: HTMLScriptElement = renderer.createElement('script');
    const lineBreak = renderer.createElement('br');
    const cuid = StateService.isMobile() ? '5217552' : '5217551';
    widgetContainer.id = 'oddsserve-csi-1';
    pushScript.type = 'text/javascript';
    setupScript.type = 'text/javascript';
    setupScript.innerHTML = `
      !function(o,d,s,e,r,v){
        o[e]=o[e]||{};o[e].queue=o[e].queue||[];var u=encodeURIComponent,w,z,
        y=d.createElement(s);try{w=!o.top.location.hostname}catch(f){w=1}y.async=!0;
        y.type="text/java"+s;y.charset="utf-8";w=!w?o.location.href:d.referrer;
        y.src="https://creative-cdn.oddsserve.com/get.js?url="
        +u(w)+"&wp="+u(r)+"&slots="+u(v.replace(/\\s/g,""));
        z=d.getElementsByTagName(s)[0];z.parentNode.insertBefore(y,z)
      }(window,document,"script","oddsServeCom","${cuid}","oddsserve-csi-1")
    `;
    pushScript.innerHTML = `oddsServeCom.queue.push("oddsserve-csi-1")`;
    tipp3Container.appendChild(setupScript);
    tipp3Container.appendChild(widgetContainer);
    tipp3Container.appendChild(pushScript);
    targetElem.insertAdjacentElement('afterend', tipp3Container);
    targetElem.insertAdjacentElement('afterend', lineBreak);
  }

  private getTipp3WidgetTargetElement(newsTextContainer: HTMLElement): HTMLElement | null {
    let targetElem: HTMLElement;
    const children = newsTextContainer.childNodes;
    if (children?.length < 4) {
      return null;
    }
    targetElem = children[2] as HTMLElement;
    const embedContainer = children[3] as HTMLElement;
    const embeds = embedContainer.getElementsByTagName('fanat-widget');
    if (embedContainer.tagName === 'DIV' || embeds?.length > 0) {
      targetElem = embedContainer;
    }
    return targetElem;
  }

}
